/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitedClientResource
 */
export interface InvitedClientResource {
    /**
     * 
     * @type {string}
     * @memberof InvitedClientResource
     */
    identityId?: string;
}

/**
 * Check if a given object implements the InvitedClientResource interface.
 */
export function instanceOfInvitedClientResource(value: object): value is InvitedClientResource {
    return true;
}

export function InvitedClientResourceFromJSON(json: any): InvitedClientResource {
    return InvitedClientResourceFromJSONTyped(json, false);
}

export function InvitedClientResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitedClientResource {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
    };
}

export function InvitedClientResourceToJSON(value?: InvitedClientResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
    };
}

